import { kgToLbs, lbsToKg } from "../dataStore"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  getConvertedWeights() {
    if (!this.store.isMetric) {
      const { weightKg } = this.formValues

      const weightLbs = Math.round(kgToLbs(weightKg || 0))

      return weightLbs
    } else {
      const { weightLbs } = this.formValues

      const weightKg = Math.round(lbsToKg(weightLbs || 0))

      return weightKg
    }
  },

  convertWeight() {
    if (!this.store.isMetric) {
      const weightLbs = this.getConvertedWeights()

      this.formValues.weightLbs = weightLbs
    } else {
      const weightKg = this.getConvertedWeights()

      this.formValues.weightKg = weightKg
    }
  },

  processFormValues() {
    const { weightKg, weightLbs } = this.formValues

    if (this.store.isMetric) {
      const convertedWeightLbs = Math.round(kgToLbs(weightKg))

      return { weightLbs: convertedWeightLbs, weightKg }
    } else {
      const convertedWeightKg = Math.round(lbsToKg(weightLbs))

      return { weightKg: convertedWeightKg, weightLbs }
    }
  },
})
